export default __webpack_public_path__ + "static/media/logo.958c65f8.png";